export default "__VITE_ASSET__BzFARDfK__"